import { BrandConfig } from '../types';
import { betmgmConfig, betmgmDemosOnlyConfig } from './betmgm.config';
import { everiConfig } from './everi.config';
import { entainConfig } from './entain.config';
import { jogoglobalConfig } from './jogoglobal.config';
import { jogoglobal2Config } from './jogoglobal2.config';
import { jogoglobalAdminConfig } from './jogoglobal-admin.config';
import { estrelabetConfig } from './estrelabet.config';

// Export all brand configurations
export const brands: Record<string, BrandConfig> = {
  betmgm: betmgmConfig,
  everi: everiConfig,
  entain: entainConfig,
  jogoglobal: jogoglobalConfig,
  jogoglobal2: jogoglobal2Config,
  estrelabet: estrelabetConfig,
  'betmgm-demos': betmgmDemosOnlyConfig,
  'jogoglobal-admin': jogoglobalAdminConfig
};

// Get brand configuration by ID
export function getBrandConfig(brandId: string): BrandConfig {
  const config = brands[brandId];
  
  if (!config) {
    throw new Error(`Brand configuration not found for: ${brandId}. User may not have valid brand assigned.`);
  }
  
  return config;
}

// Get all available brands
export function getAllBrands(): BrandConfig[] {
  return Object.values(brands);
}

// Get brand by name (case-insensitive)
export function getBrandByName(name: string): BrandConfig | undefined {
  const normalizedName = name.toLowerCase();
  return Object.values(brands).find(
    brand => brand.name.toLowerCase() === normalizedName
  );
}

export { betmgmConfig, everiConfig, entainConfig, jogoglobalConfig, jogoglobal2Config, jogoglobalAdminConfig, estrelabetConfig };
